export default __webpack_public_path__ + "static/media/CAPABILITY_CNC.3a9c67cc.png";